import { IIdentityConfiguration } from "../../reducers/bookings/types";
import { IdentityVerificationStatus } from "../../reducers/website/types";

export const hasIdvCredits = (config?: IIdentityConfiguration | null) =>
  (config?.creditUsage?.availableCredits ?? 0) > 0;

export const isIdvStatusPassed = (status?: string) =>
  status === IdentityVerificationStatus.APPROVED ||
  status === IdentityVerificationStatus.IN_REVIEW;
